import { applyModule, applyModules } from "./modules/utils"
import { VimeoPlayer } from "./modules/vimeo-player"
import { SwiperCarousel } from "./modules/swiper-carousel"
import { AnnotatedVideo } from "./modules/annotated-video"

declare var jQuery

applyModules( '.video[data-vimeo]', VimeoPlayer )
applyModules( '.swiper',            SwiperCarousel )
applyModules( '.annotated-video',   AnnotatedVideo )

;(function($){

  $('html').removeClass('no-js')

})(jQuery)